function resourceCarousel() {
    $('.resource-slider-xs').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
            {
                // breakpoint: 767,
                // settings: "unslick"
            }
        ]
    });

}
resourceCarousel();

function resourceTabCarousel() {
    $('.tabresource-slider').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: false,
        arrows: true,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true,
                }
              },
              {
                breakpoint: 575,
                settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
                }
              },
            {
                breakpoint: 767,
                settings: "unslick"
            }
        ]
    });

}

resourceTabCarousel();
// window.addEventListener('resize', function(event){
//     resourceTabCarousel();
// });
// $(window).resize(function(){
//   resourceTabCarousel();
// });
// $('.responsive-tabs a[data-toggle="tab"]').on('shown.bs.tab', function(e) {
//   resourceTabCarousel();
// });
